import { render, staticRenderFns } from "./DefaultEmailsNewView.vue?vue&type=template&id=4f8c60e6&scoped=true"
import script from "./DefaultEmailsNewView.vue?vue&type=script&lang=js"
export * from "./DefaultEmailsNewView.vue?vue&type=script&lang=js"
import style0 from "./DefaultEmailsNewView.vue?vue&type=style&index=0&id=4f8c60e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c60e6",
  null
  
)

export default component.exports